<template> 


    <div>
        <div class="row card-container">
            <div class="col deploymentServer-card" v-for="deploymentServer in deploymentServers" :key="deploymentServer.deploymentServerId">
                <div class="deploymentServer-info">
                
                         <div class="deploymentServer-image">
                            <img :src="require('@/assets/racknerd.png')" alt="DeploymentServer image" class="deploymentServer-img" />
                        </div>

        		<div class="deploymentServer-name"><a :href="'#deploymentServer/' +  deploymentServer.deploymentServerId"  target="_blank" class="deploymentServer-link">{{ deploymentServer.deploymentServerId }}</a></div>
		  	        		<div class="deploymentServer-detail">{{ deploymentServer.deploymentUrl }}</div>
	        		<div class="deploymentServer-detail">{{ deploymentServer.hostname }}</div>
	        		<div class="deploymentServer-detail">{{ deploymentServer.ipAddress }}</div>
	        		<div class="deploymentServer-detail">{{ deploymentServer.ownerId }}</div>
	  
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>

export default {
    components: {
    },
    props: {
        deploymentServers: Array,
    },

    methods: {

    },
};
</script>
  
<style scoped>
.card-container {
    display: flex;
    column-gap: 15px;
    flex-wrap: wrap;
    margin: 5px;

}

.card {
    max-width: 230px;

}

.deploymentServer-picture-view {
    margin-bottom: 15px;
    /* Separate each row from the content below */
}

.deploymentServer-card {
    max-width: 250px;
    min-width: 250px;
    border-radius: 30px;
    padding: 0px;
    margin-bottom: 25px;
    /* Separate each card */
}


.deploymentServer-info {
    margin-top: 0px;
}

.deploymentServer-name {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 2px;
    line-height: 1.2;
}

.deploymentServer-details p {
    margin-top: 0px;
    text-align: left;
}

.deploymentServer-link {
    display: inline;
    margin-top: 5px;
    color: #1890ff;
}

.deploymentServer-img {
  width: 80%;
  height: 100%;
  object-fit: contain;  /* show entire image without cropping */
}

.deploymentServer-image {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff; /* optional, gives clean padding around image */
}

</style>
  
